import { put, delay, call } from "redux-saga/effects";
import axios from "../../../config/AxiosConfig";
import {
	clearTwofactorAuthData,
	getLanguageCode
} from "../../../helpers/helpers";
import {
	activateAccountSuccess,
	activateAccountFail,
	activateAccountisSpinning,
	twoFactorLoginFail,
	getTwoFactorQrCodeSuccess
} from "../../actions/activateAccount/activateAccountActions";
import { authStart } from "../../actions/index";
import {
	ACTIVATE_ACCOUNT_API,
	VERIFY_TWO_FACTOR_USER_API,
	VERIFY_TWO_FACTOR_LOGIN_API,
	GET_TWO_FACTOR_QR_CODE
} from "../../actions/apiCollections";

import { authSuccess, checkAuthTimeout, setAlert } from "../../actions/index";

import { getCurrentUserSaga } from "../getCurrentUserSaga";
import {
	getCampaignSettingsSaga,
	getSiteSettingsSaga
} from "../siteSettingsSaga";

export function* activateAccountSaga(action) {
	yield put(activateAccountisSpinning(true));
	try {
		const response = yield axios.get(
			ACTIVATE_ACCOUNT_API + action.userId + "/" + action.verificationId,
			{ params: { lng: getLanguageCode() } }
		);
		if (response.data.message?.authData?.url) {
			yield put(activateAccountSuccess(response.data.message));
			yield put(activateAccountisSpinning(false));
		} else {
			yield put(activateAccountSuccess(response.data.data.user));
			const expirationTokenTime = 10800;
			const expirationDate = yield new Date(
				new Date().getTime() + expirationTokenTime * 1000
			);
			yield localStorage.setItem("token", response.data.token);
			yield localStorage.setItem("expirationDate", expirationDate);
			yield localStorage.setItem("email", action.email);
			yield localStorage.setItem("slug", response.data.data.user.slug);
			yield localStorage.setItem("userType", response.data.data.user.userType);
			yield call(getCurrentUserSaga);
			yield call(getCampaignSettingsSaga);
			yield call(getSiteSettingsSaga);
			yield put(authSuccess(response.data.token));
			yield put(checkAuthTimeout(expirationTokenTime));
			yield delay(500);
			yield put(setAlert(true));
			yield delay(8000);
			yield put(setAlert(false));
			yield put(activateAccountisSpinning(false));
		}
	} catch (error) {
		yield put(activateAccountFail(error.response.data.message));
	}
}

export function* twoFactorUserActivateAccountSaga(action) {
	try {
		const response = yield axios.post(VERIFY_TWO_FACTOR_USER_API, action, {
			params: { lng: getLanguageCode() }
		});

		yield put(activateAccountSuccess(response.data.data.user));
		const expirationTokenTime = 10800;
		const expirationDate = yield new Date(
			new Date().getTime() + expirationTokenTime * 1000
		);
		yield localStorage.setItem("token", response.data.token);
		yield localStorage.setItem("expirationDate", expirationDate);
		yield localStorage.setItem("email", action.email);
		yield localStorage.setItem("slug", response.data.data.user.slug);
		yield localStorage.setItem("userType", response.data.data.user.userType);
		yield call(getCurrentUserSaga);
		yield call(getCampaignSettingsSaga);
		yield call(getSiteSettingsSaga);
		yield put(authSuccess(response.data.token));
		yield put(checkAuthTimeout(expirationTokenTime));
		yield delay(500);
		yield put(setAlert(true));
		yield delay(8000);
		yield put(setAlert(false));
	} catch (error) {
		yield put(activateAccountFail(error.response.data.message));
	}
}

export function* twoFactorLoginSaga(action) {
	yield put(authStart());
	yield put(activateAccountisSpinning(true));
	try {
		const response = yield axios.post(VERIFY_TWO_FACTOR_LOGIN_API, action, {
			params: { lng: getLanguageCode() }
		});

		yield put(activateAccountSuccess(response.data.data.user));
		const expirationTokenTime = 10800;
		const expirationDate = yield new Date(
			new Date().getTime() + expirationTokenTime * 1000
		);

		yield localStorage.setItem("token", response.data.token);
		yield localStorage.setItem("expirationDate", expirationDate);
		yield localStorage.setItem("email", action.email);
		yield localStorage.setItem("slug", response.data.data.user.slug);
		yield localStorage.setItem("userType", response.data.data.user.userType);
		yield call(getCurrentUserSaga);
		yield call(getCampaignSettingsSaga);
		yield call(getSiteSettingsSaga);
		yield put(authSuccess(response.data.token));
		yield put(checkAuthTimeout(expirationTokenTime));
		yield localStorage.removeItem("twoFactorLoginStatus");
		yield localStorage.removeItem("twoFactorLoginQRLink");
		yield localStorage.removeItem("twoFactorLoginUserEmail");
		yield clearTwofactorAuthData();

		yield delay(500);
		yield put(setAlert(true));
		yield delay(8000);
		yield put(setAlert(false));
		yield put(activateAccountisSpinning(false));
	} catch (error) {
		yield put(twoFactorLoginFail(error.response.data.message));
		yield put(activateAccountisSpinning(false));
	}
}

export function* getTwoFactorQrCodeSaga(action) {
	try {
		const response = yield axios.get(GET_TWO_FACTOR_QR_CODE);
		yield put(getTwoFactorQrCodeSuccess(response.data.message.url));
	} catch (error) {
		console.log(error);
	}
}
